import { useEffect, useState } from 'react'
import axios from 'axios'
import Problems from '../components/Homepage/Problems';

function ProblemList() {
  const [problems, setProblems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getProblems = async () => {
    try {
      const res = await axios.get("https://alfa-leetcode-api.onrender.com/problems?limit=20");
      setProblems(res.data.problemsetQuestionList);
    } catch (err) {
      try{
        <Problems/>
      }catch(err){
        setError(err.message);
      console.error("Error fetching problems:", err);
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getProblems();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
    <div className="p-4 text-white">
    <h1 className="text-3xl font-bold mb-4">Problems</h1>
    <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {problems.map((problem) => (
        <li
          key={problem.id}
          className="bg-[#393E46] p-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
        >
          <h2 className="text-xl font-semibold">{problem.title || "Untitled Problem"}</h2>
          <p className="text-gray-300 text-sm mt-2">Difficulty: {problem.difficulty || "Unknown"}</p>
          <a href={`https://leetcode.com/problems/${problem.title.toLowerCase().replace(/\s+/g, "-")}/description/`} target="blank" className="text-white">
          <button className="mt-2 bg-gradient-to-r from-violet-500 to-red-500 text-white py-2 px-4 rounded hover:bg-gradient-to-l transition-all duration-300">
            View Problem
          </button></a>
        </li>
      
      ))}
    </ul>
  </div>
  </>
  )
}

export default ProblemList;